// API adresi: sayfa nerede açıksa oraya gider.
// Mobil (Capacitor): REACT_APP_API_URL ile override edilebilir.
function getBaseURL() {
  if (typeof window === "undefined") return "http://localhost:5000/api";

  const envUrl =
    typeof process !== "undefined" && process.env?.REACT_APP_API_URL;
  const isDev = process.env.NODE_ENV === "development";
  const devPort = typeof window !== "undefined" ? window.location.port || "" : "";
  const isCraDevPort = /^300[0-9]$/.test(devPort);

  // Mobil uygulama (APK)
  if (window.Capacitor?.isNativePlatform?.()) {
    if (envUrl && String(envUrl).trim()) {
      return String(envUrl).trim().replace(/\/+$/, "");
    }
    return "https://lisans.pozitifofis.com.tr/api";
  }

  // CRA dev (localhost veya LAN IP, HTTP/HTTPS): setupProxy üzerinden git
  if (isDev && isCraDevPort) {
    return `${window.location.protocol}//${window.location.host}/api`;
  }

  // .env ile açık API (production build veya doğrudan backend)
  if (envUrl && String(envUrl).trim()) {
    return String(envUrl).trim().replace(/\/+$/, "");
  }

  if (window.location.hostname === "lisans.pozitifofis.com.tr") {
    return "https://lisans.pozitifofis.com.tr/api";
  }

  // Production build aynı sunucuda (IP veya hostname)
  return `${window.location.protocol}//${window.location.host}/api`;
}

const config = {
  get baseURL() {
    return getBaseURL();
  },
};

export default config;
